import { getTestIds } from 'seagull/utils/TestIds';
export const GetHelpMeWriteTriggerTID = (parentTestId)=>getTestIds(parentTestId);
